const ONLY_SHOW_VIL = false;
class Logger {
    static info(SHOW_LOGS, tag, ...messages) {
        if (ONLY_SHOW_VIL)
            return;
        SHOW_LOGS && console.log('\x1b[34m%s\x1b[0m', `INFO: ${tag}.`, ...messages);
    }
    static error(SHOW_LOGS, tag, ...messages) {
        if (ONLY_SHOW_VIL)
            return;
        SHOW_LOGS && console.log('\x1b[31m%s\x1b[0m', `ERROR: ${tag}.`, ...messages);
    }
    static debug(SHOW_LOGS, tag, ...messages) {
        if (ONLY_SHOW_VIL)
            return;
        SHOW_LOGS && console.log('\x1b[35m%s\x1b[0m', `DEBUG: ${tag}.`, ...messages);
    }
    static warn(SHOW_LOGS, tag, ...messages) {
        if (ONLY_SHOW_VIL)
            return;
        SHOW_LOGS && console.log('\x1b[33m%s\x1b[0m', `WARN: ${tag}.`, ...messages);
    }
    static VIL(message) {
        console.log('\x1b[35m%s\x1b[0m', `VIL: ${message}`);
    }
}
export default Logger;
